<template>
    <div class="stripe-form">
        <!-- Display a payment form -->
        <form id="payment-form">
            <div id="payment-element">
                <!--Stripe.js injects the Payment Element-->
            </div>
            <v-fade-transition>
                <v-btn v-if="inited" color="primary" :loading="loading" :disabled="loading" block depressed large class="mt-5" @click="handleSubmit">
                    Recharge
                </v-btn>
            </v-fade-transition>

            <div id="payment-message" class="hidden"></div>
        </form>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import Vue from 'vue'

export default {
    components: {
    //   'paypal-buttons': PayPalButton,
    },
    props: {
        amount: {},
        disabled: {type: Boolean, default: false},
        email: {},
        method: {default: 'card'},
    },
    data(){
        return {
            stripeObject: null,
            elements: null,
            loading: false,
            inited: false,
        }
    },
    computed: {
        ...GlobalComputed
    },
    watch: {
        amount(){
            
        }
    },
    methods: {
        ...GlobalMethods,
        async handleSubmit(){
            this.loading = true;
            try {
                const { error, paymentIntent } = await this.stripeObject.confirmPayment({
                    elements: this.elements,
                    confirmParams: {
                        return_url: window.apiUrl + "/stripe/complete",
                        receipt_email: this.email,
                    },
                    redirect: 'if_required',
                });

                if (error) {
                    if (error.type === "card_error" || error.type === "validation_error") {
                        this.showMsg(error.message, 'error');
                    } else {
                        this.showMsg('An unexpected error occurred.', 'error');
                    }
                    return;
                }

                if (paymentIntent && paymentIntent.status === "succeeded") {
                    this.showMsg("Your payment has been successfully completed.", "success");
                    this.$emit("payment-succeeded", paymentIntent);
                    return;
                }

                if (paymentIntent && paymentIntent.status === "processing") {
                    this.showMsg("Your payment is processing. Your balance may update shortly.", "success");
                    this.$emit("payment-succeeded", paymentIntent);
                    return;
                }

                this.$emit("payment-succeeded");
            } finally {
                this.loading = false;
            }
        },
        initialize(){
            const data = {amount: this.amount, method: this.method};
            window.axios.post('/wallet/recharge/stripe/init', data).then(response=>{
                const clientSecret = response.data.clientSecret;
                const stripeKey = response.data.stripePK;
                this.initPaymentElements(stripeKey, clientSecret);
            }).catch(e=>{
                this.showMsg('Error occurred during initializing payment', 'error');
                console.error(e)
            })
        },

        initPaymentElements(stripeKey, clientSecret){
            const stripe = new window.Stripe(stripeKey);
            this.stripeObject = stripe;

            const elements = this.stripeObject.elements({ clientSecret });
            this.elements = elements;
            const paymentElementOptions = {
                layout: "tabs",
            };

            const paymentElement = this.elements.create("payment", paymentElementOptions);
            paymentElement.mount("#payment-element");
            this.inited = true;
        }
    },
    created(){
        
    },
    mounted(){
        this.initialize();
    }
};
</script>
<style lang="scss" scoped>
.paypal-buttons{
    position: relative;
    .disabled-buttons-overlay{
        z-index: 100!important;
    }
}
</style>